// removed by extract-text-webpack-plugin
module.exports = {"modalContainer":"book-appointment-modal_modalContainer--2IkhHmcq","green":"book-appointment-modal_green--Bq9nXb_A","headerLarge":"book-appointment-modal_headerLarge--3u3ebvt9","headerSmall":"book-appointment-modal_headerSmall--2crKtDd3","body":"book-appointment-modal_body--3XyC4GBv","authentication":"book-appointment-modal_authentication--2gUZSkGu","details":"book-appointment-modal_details--3E40Ygen","loginMessage":"book-appointment-modal_loginMessage--1TmECtH0"};


//////////////////
// WEBPACK FOOTER
// ./components/doctify-modals/src/styles/book-appointment-modal.scss
// module id = 1646
// module chunks = 0